// FORGE Coming Soon v2 — The Factory Awakens
import '../shared/fonts.css';
import './coming-soon.css';
import { initChat } from '../shared/chatbot.js';
import { initTrailer } from './trailer.js';
import { LAUNCH_FALLBACK } from './trailer-date.js';
import { wordmarkHTML } from '../shared/signet.js';
import { bookingHTML, mountBooking } from './booking.js';
import { ladeBetaProgramm, betaHtml } from '../shared/beta-programm.js';

const SB_URL = 'https://ckkeuasgmppfwlhblbcx.supabase.co';
const SB_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImNra2V1YXNnbXBwZndsaGJsYmN4Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzU2NTMwNzMsImV4cCI6MjA5MTIyOTA3M30.YfjZg83FaPFFUKhK2YIDsZSyinCbyNCLqlHOC7bCFGA';
// Erstbesuch (keine gespeicherte Wahl): Browser-Sprache respektieren wenn Englisch,
// sonst bleibt Deutsch der Standard — gespeicherte Wahl hat immer Vorrang.
function _detectInitialLang() {
  var saved = localStorage.getItem('forge_lang');
  if (saved === 'de' || saved === 'en') return saved;
  var nav = (navigator.language || navigator.userLanguage || '').toLowerCase();
  return nav.indexOf('en') === 0 ? 'en' : 'de';
}
const lang = _detectInitialLang();

// Defaults — werden durch Supabase-Config überschrieben
let LAUNCH = new Date(LAUNCH_FALLBACK);
let SPOTS  = 40 + Math.floor(Math.random() * 8);
let _announcements = [];
let _beta = null;   // Beta-Programm aus der DB (beta.js), null = kein Hinweis

window.CSLang = { set: l => { localStorage.setItem('forge_lang', l); location.reload(); } };
document.documentElement.lang = lang;

const T = {
  de: {
    meta_title: 'FORGE – Automatisierte Softwareherstellung & Vibe Coding',
    meta_desc: 'Automatisierte Softwareherstellung mit 29 KI-Agenten: Vibe Coding mit SAFe-Struktur und OKR-Integration – von der Anforderung bis zum Pull Request, geprüft und abgenommen.',
    badge: '🏭  Startet am 1. Oktober 2026',
    h1a: 'Während Ihr Team noch',
    h1b: 'im Planning sitzt,',
    h1c: 'hat FORGE schon deployed.',
    sub: 'Automatisierte Softwareherstellung mit 29 KI-Agenten · SAFe-Framework · OKR-Integration<br>Vibe Coding mit Struktur: von der Idee bis zum Production-Deploy — <em>vollautomatisch in 15 Minuten</em>.',
    warn: '⚠️ Warnung: Macht Ihre Retro sehr kurz. (Es gab nichts zu beklagen.)',
    cd_lbl: 'Startet in',
    D:'TAGE', H:'STD', M:'MIN', S:'SEK',
    act: [
      '⚡ DEV schreibt Unit-Tests für ein Payment-Feature',
      '🔀 MAX koordiniert 6 Agenten für Feature #1249',
      '📊 OSCAR aktualisiert OKR-Progress für Q3 2026',
      '🔍 VERA analysiert Backlog mit 134 Items',
      '✅ STELLA reviewed Pull Request #2041',
      '🛡️ GARD prüft DSGVO-Konformität des letzten Commits',
      '📝 TARA erstellt 8 JIRA-Subtasks für Epic #4823',
      '🧪 QUINN führt 247 Integrationstests durch',
      '🚀 NOVA onboardet neuen Kunden in 4 Minuten',
      '🔎 SCAN analysiert 2.341 Abhängigkeiten auf Sicherheitslücken',
      '📱 MARK erstellt LinkedIn-Post für das neue Feature',
      '📋 CLEO bereitet CEO-Brief für Montagmorgen vor',
      '⚙️ FELIX plant den nächsten Program Increment',
      '🏗️ ARCH reviewed die neue Microservice-Architektur',
    ],
    s1n:'29',    s1l:'KI-Agenten',
    s2n:'9–15',  s2l:'Min. pro Feature',  s2x:'Kein Tippfehler.',
    s3n:'2.847', s3l:'Features (Beta)',
    fq: 'Was macht FORGE,<br>während Sie schlafen?',
    fa: 'Features bauen. Backlogs leeren. Code reviewen. OKRs aktualisieren. Pull Requests mergen. Meetings absagen.',
    fp: '« Wer hat das gemacht? — Wir. 29 Agenten. Wir schlafen nicht. »',
    ag_l: 'Ihr neues Team — 29 Agenten, bereit zum Deploy',
    pp_l: 'Der Feature-Loop in Aktion',
    pp_f: 'NOVA → MAX → OSCAR → VERA → STELLA → TARA → DEV → QUINN → OPS → MONA',
    pp_s: 'Jeder Schritt vollautomatisch. Keine Meetings. Keine Wartezeiten.',
    spots: `Noch ${SPOTS} Early-Access-Plätze verfügbar`,
    cta_h: 'Früh-Zugang sichern',
    cta_s: 'Founder-Preise gelten nur bis zum Launch. Danach: reguläre Preise.',
    ph:'ihre@email.de', btn:'Meinen Platz sichern →',
    cal_or: 'oder',
    cal_h: 'Termin direkt hier auswählen',
    cal_note: 'Kein Fremddienst, kein Cookie: Tag und Uhrzeit wählen, Name und E-Mail eintragen — fertig. Ihre Angaben bleiben bei uns, Einzelheiten in der <a href="/pages/datenschutz/">Datenschutzerklärung</a>.',
    cal_sub: 'Unverbindlich, 15 Minuten, direkt mit Rainer Schulz.',
    cal_loading: 'Freie Termine werden geladen …',
    cal_none: 'Aktuell ist kein Termin frei. Schreiben Sie uns gern eine E-Mail — wir finden einen.',
    cal_retry: 'Erneut versuchen',
    cal_day: 'Tag',
    cal_time: 'Uhrzeit',
    cal_tz: 'Alle Zeiten in Ihrer Zeitzone ({tz}). Dauer: 15 Minuten.',
    cal_back: 'Anderer Termin',
    cal_name_lbl: 'Ihr Name',
    cal_name_ph: 'Vorname Nachname',
    cal_mail_lbl: 'Ihre E-Mail-Adresse',
    cal_mail_ph: 'ihre@email.de',
    cal_phone_lbl: 'Telefonnummer',
    cal_phone_ph: '+49 170 1234567',
    // Steht am Feld, nicht in einer Fussnote: „warum wollen die meine Nummer?"
    // ist die Frage, die sonst zum Abbruch fuehrt.
    cal_phone_note: 'Nur für den Fall, dass am Termin die Technik klemmt — angerufen werden Sie sonst nicht.',
    cal_topic_lbl: 'Worum geht es?',
    cal_msg_opt: '(optional)',
    cal_topic_ph: 'Bitte wählen — oder unten frei schreiben',
    // Die Themen sind die, mit denen Interessenten tatsächlich kommen. Wer
    // seines wiederfindet, klickt es an; wer nicht, schreibt darunter weiter.
    cal_topics: [
      { v: 'bestand',     l: 'Bestehende Anwendung übernehmen oder ablösen' },
      { v: 'neubau',      l: 'Neues Produkt von Grund auf bauen' },
      { v: 'okr',         l: 'OKR und Zielsteuerung' },
      { v: 'safe',        l: 'SAFe, Backlog und Jira-Anbindung' },
      { v: 'agenten',     l: 'Welche Agenten zu uns passen' },
      { v: 'integration', l: 'Anbindung an unsere Werkzeuge (GitHub, Jira, n8n)' },
      { v: 'preise',      l: 'Preise, Pakete und Early Access' },
      { v: 'recht',       l: 'Datenschutz, DSGVO und EU AI Act' },
      { v: 'sonstiges',   l: 'Etwas anderes' },
    ],
    cal_msg_lbl: 'Möchten Sie etwas ergänzen?',
    cal_msg_ph: 'Ein Satz genügt — z. B. „Wir haben eine bestehende Anwendung und überlegen, sie zu übernehmen“. Dann ist das Gespräch von der ersten Minute an konkret.',
    cal_req: '* Pflichtfeld. Ohne Name und E-Mail-Adresse können wir den Termin weder bestätigen noch absagen.',
    cal_book: 'Termin verbindlich buchen',
    cal_busy: '⏳ wird gebucht …',
    cal_ok: 'Termin steht!',
    cal_ok_sub: 'Sie bekommen eine Bestätigung per E-Mail. Wenn etwas dazwischenkommt, antworten Sie einfach darauf.',
    cal_e_name: 'Bitte tragen Sie Ihren Namen ein.',
    cal_e_mail: 'Diese E-Mail-Adresse sieht nicht vollständig aus.',
    cal_e_phone: 'Diese Telefonnummer sieht nicht vollständig aus. Lassen Sie das Feld sonst einfach leer.',
    cal_e_slot: 'Dieser Termin wird nicht mehr angeboten. Bitte wählen Sie einen anderen.',
    cal_e_taken: 'Dieser Termin war gerade schneller weg. Bitte wählen Sie einen anderen.',
    cal_e_limit: 'Sie haben bereits drei Termine offen. Bitte nehmen Sie die zuerst wahr.',
    cal_e_net: 'Das hat nicht geklappt. Bitte versuchen Sie es noch einmal.',
    cal_t_day: 'Zeigt die freien Uhrzeiten am {v}',
    cal_t_slot: 'Wählt {v} und öffnet das Formular',
    cal_t_topic: 'Wählt das Thema, um das es im Gespräch gehen soll',
    cal_t_back: 'Zurück zur Auswahl von Tag und Uhrzeit',
    cal_t_book: 'Bucht den gewählten Termin verbindlich und sperrt ihn für andere',
    cal_t_busy: 'Die Buchung läuft — bitte einen Moment',
    cal_t_retry: 'Lädt die freien Termine erneut',
    ok: '🎉 Sie sind dabei! Wir melden uns vor allen anderen.',
    prom: 'Kein Spam. Kein Newsletter. Genau eine E-Mail — wenn FORGE startet.',
    priv: 'Mit dem Absenden stimmen Sie unserer <a href="/pages/datenschutz/">Datenschutzerklärung</a> zu.',
    foot: 'Entwickelt von Menschen. Optimiert von 29 KI-Agenten.<br>Doppelt geprüft von GARD. (GARD schläft nicht.)',
    legal: { imp: 'Impressum', dat: 'Datenschutz', agb: 'AGB' },
    beta_t: '🧪 Kostenlose Beta-Phase',
    beta_s: 'Wer sich vom {von} bis {bis} anmeldet, nutzt FORGE bis {beta_bis} kostenlos — im vollen Umfang des gewählten Tarifs, inklusive Loop-Kontingent.',
    beta_offen: 'Die Beta läuft: Wer sich bis {bis} anmeldet, nutzt FORGE bis {beta_bis} kostenlos — im vollen Umfang des gewählten Tarifs, inklusive Loop-Kontingent.',
    beta_r: 'Danach {pct} % Beta-Rabatt bis {rabatt_bis}.',
    beta_danach: 'Danach geht es nahtlos im regulären Tarif weiter.',
  },
  en: {
    meta_title: 'FORGE – Automated Software Production & Vibe Coding',
    meta_desc: 'Automated software production with 29 AI agents: vibe coding with SAFe structure and OKR integration – from requirement to pull request, reviewed and accepted.',
    badge: '🏭  Launching October 1, 2026',
    h1a: 'While your team',
    h1b: 'is still in planning,',
    h1c: 'FORGE already shipped.',
    sub: 'Automated software production with 29 AI agents · SAFe framework · OKR integration<br>Vibe coding with structure: from idea to production deploy — <em>fully automated in 15 minutes</em>.',
    warn: '⚠️ Warning: Makes your retro very short. (Nothing left to complain about.)',
    cd_lbl: 'Launching in',
    D:'DAYS', H:'HRS', M:'MIN', S:'SEC',
    act: [
      '⚡ DEV writing unit tests for a payment feature',
      '🔀 MAX coordinating 6 agents for feature #1249',
      '📊 OSCAR updating OKR progress for Q3 2026',
      '🔍 VERA analyzing backlog with 134 items',
      '✅ STELLA reviewing Pull Request #2041',
      '🛡️ GARD checking GDPR compliance of the last commit',
      '📝 TARA creating 8 JIRA subtasks for Epic #4823',
      '🧪 QUINN running 247 integration tests',
      '🚀 NOVA onboarding a new client in 4 minutes',
      '🔎 SCAN analyzing 2,341 dependencies for vulnerabilities',
      '📱 MARK creating a LinkedIn post for the new feature',
      '📋 CLEO preparing Monday morning CEO brief',
      '⚙️ FELIX planning the next Program Increment',
      '🏗️ ARCH reviewing the new microservice architecture',
    ],
    s1n:'29',    s1l:'AI Agents',
    s2n:'9–15',  s2l:'Min. per Feature',  s2x:'Yes, really.',
    s3n:'2,847', s3l:'Features (Beta)',
    fq: 'What does FORGE do<br>while you sleep?',
    fa: 'Ships features. Empties backlogs. Reviews code. Updates OKRs. Merges pull requests. Cancels meetings.',
    fp: '« Who did all that? — Us. 29 agents. We don\'t sleep. »',
    ag_l: 'Your new team — 29 agents ready to deploy',
    pp_l: 'The Feature Loop in Action',
    pp_f: 'NOVA → MAX → OSCAR → VERA → STELLA → TARA → DEV → QUINN → OPS → MONA',
    pp_s: 'Fully automated. No meetings. No waiting.',
    spots: `${SPOTS} Early Access spots remaining`,
    cta_h: 'Secure Early Access',
    cta_s: 'Founder pricing ends at launch. Regular pricing after that.',
    ph:'your@email.com', btn:'Reserve my spot →',
    cal_or: 'or',
    cal_h: 'Pick a time right here',
    cal_note: 'No third-party service, no cookies: choose a day and a time, enter your name and email — done. Your details stay with us; see our <a href="/pages/datenschutz/">privacy policy</a> for the specifics.',
    cal_sub: 'No strings attached, 15 minutes, directly with Rainer Schulz.',
    cal_loading: 'Loading available times …',
    cal_none: 'No times are free right now. Just send us an email — we will find one.',
    cal_retry: 'Try again',
    cal_day: 'Day',
    cal_time: 'Time',
    cal_tz: 'All times in your time zone ({tz}). Duration: 15 minutes.',
    cal_back: 'Different time',
    cal_name_lbl: 'Your name',
    cal_name_ph: 'First name, last name',
    cal_mail_lbl: 'Your email address',
    cal_mail_ph: 'your@email.com',
    cal_phone_lbl: 'Phone number',
    cal_phone_ph: '+49 170 1234567',
    cal_phone_note: 'Only in case the technology fails us at the appointment — we will not call you otherwise.',
    cal_topic_lbl: 'What is it about?',
    cal_msg_opt: '(optional)',
    cal_topic_ph: 'Please choose — or just write below',
    cal_topics: [
      { v: 'bestand',     l: 'Taking over or replacing an existing application' },
      { v: 'neubau',      l: 'Building a new product from scratch' },
      { v: 'okr',         l: 'OKR and goal management' },
      { v: 'safe',        l: 'SAFe, backlog and Jira integration' },
      { v: 'agenten',     l: 'Which agents fit our team' },
      { v: 'integration', l: 'Connecting our tools (GitHub, Jira, n8n)' },
      { v: 'preise',      l: 'Pricing, plans and early access' },
      { v: 'recht',       l: 'Privacy, GDPR and the EU AI Act' },
      { v: 'sonstiges',   l: 'Something else' },
    ],
    cal_msg_lbl: 'Anything to add?',
    cal_msg_ph: 'One sentence is enough — e.g. “We have an existing application and are considering handing it over”. That way the call is concrete from the first minute.',
    cal_req: '* Required. Without your name and email address we can neither confirm nor cancel the appointment.',
    cal_book: 'Book this time',
    cal_busy: '⏳ booking …',
    cal_ok: 'You are booked!',
    cal_ok_sub: 'A confirmation is on its way to your inbox. If something comes up, just reply to it.',
    cal_e_name: 'Please enter your name.',
    cal_e_mail: 'That email address does not look complete.',
    cal_e_phone: 'That phone number does not look complete. Otherwise just leave the field empty.',
    cal_e_slot: 'That time is no longer on offer. Please pick another one.',
    cal_e_taken: 'Someone was faster for that time. Please pick another one.',
    cal_e_limit: 'You already have three calls booked. Please attend those first.',
    cal_e_net: 'That did not work. Please try again.',
    cal_t_day: 'Shows the free times on {v}',
    cal_t_slot: 'Selects {v} and opens the form',
    cal_t_topic: 'Selects the topic the call should be about',
    cal_t_back: 'Back to choosing a day and time',
    cal_t_book: 'Books the selected time and blocks it for everyone else',
    cal_t_busy: 'Booking in progress — one moment',
    cal_t_retry: 'Reloads the available times',
    ok: '🎉 You\'re in! We\'ll reach out before everyone else.',
    prom: 'No spam. No newsletter. One email — when FORGE launches.',
    priv: 'By submitting, you agree to our <a href="/pages/datenschutz/">privacy policy</a>.',
    foot: 'Built by humans. Optimized by 29 AI agents.<br>Double-checked by GARD. (GARD doesn\'t sleep.)',
    legal: { imp: 'Imprint', dat: 'Privacy', agb: 'Terms' },
    beta_t: '🧪 Free beta phase',
    beta_s: 'Sign up between {von} and {bis} and use FORGE free of charge until {beta_bis} — the full scope of your plan, including the loop quota.',
    beta_offen: 'The beta is running: sign up by {bis} and use FORGE free of charge until {beta_bis} — the full scope of your plan, including the loop quota.',
    beta_r: 'After that, a {pct} % beta discount until {rabatt_bis}.',
    beta_danach: 'After that, you continue seamlessly on your regular plan.',
  },
};

const AGENTS = [
  { id:'OSCAR', c:'#3B6D11', r:'OKR Strategy',
    de:'Definiert Objectives, trackt Key Results und schlägt quartalsweise OKR-Anpassungen vor.',
    en:'Defines objectives, tracks key results and proposes quarterly OKR adjustments.' },
  { id:'MAX',   c:'#854F0B', r:'Orchestrator',
    de:'Koordiniert alle 29 Agenten und plant den vollautomatischen Feature-Loop.',
    en:'Coordinates all 29 agents and plans the fully automated feature loop.' },
  { id:'PORTO', c:'#B0ADB8', r:'Portfolio ✦',
    de:'Verwaltet das Portfolio-Backlog, balanciert Kapazität und strategischen Demand. (Enterprise)',
    en:'Manages the portfolio backlog, balances capacity and strategic demand. (Enterprise)' },
  { id:'ELSA',  c:'#B0ADB8', r:'Epic Owner ✦',
    de:'Erstellt und verfeinert Business Epics, prüft strategische Ausrichtung. (Enterprise)',
    en:'Creates and refines business epics, checks strategic alignment. (Enterprise)' },
  { id:'ARCH',  c:'#B0ADB8', r:'Architect ✦',
    de:'Trifft Architekturentscheidungen, erstellt ADRs und reviewed Systemdesign. (Enterprise)',
    en:'Makes architecture decisions, creates ADRs and reviews system design. (Enterprise)' },
  { id:'PRIMA', c:'#0F6E56', r:'Program Mgr',
    de:'Koordiniert PI-Planning und überwacht die Ziele des Program Increments.',
    en:'Coordinates PI planning and monitors Program Increment objectives.' },
  { id:'FELIX', c:'#085041', r:'Feature Owner',
    de:'Zerlegt Epics in Features, schreibt Feature-Descriptions und pflegt den Backlog.',
    en:'Breaks epics into features, writes feature descriptions and maintains the backlog.' },
  { id:'VERA',  c:'#1D9E75', r:'Backlog Mgr',
    de:'Verfeinert User Stories, koordiniert Story-Schätzungen und Team-Kapazität.',
    en:'Refines user stories, coordinates story estimates and team capacity.' },
  { id:'RITA',  c:'#B0ADB8', r:'RTE ✦',
    de:'Managed ART-Events, Release-Koordination und PI-Objectives. (Enterprise)',
    en:'Manages ART events, release coordination and PI objectives. (Enterprise)' },
  { id:'SAM',   c:'#185FA5', r:'Sprint Agent',
    de:'Koordiniert Sprint-Planung, Daily-Stand-ups und trackt Team-Velocity.',
    en:'Coordinates sprint planning, daily stand-ups and tracks team velocity.' },
  { id:'STELLA',c:'#0C447C', r:'Story Writer',
    de:'Schreibt User Stories mit BDD-Szenarien und Akzeptanzkriterien direkt in Jira.',
    en:'Writes user stories with BDD scenarios and acceptance criteria directly in Jira.' },
  { id:'TARA',  c:'#042C53', r:'Test Analyst',
    de:'Erstellt Jira-Subtasks, Testpläne und detaillierte Testspezifikationen.',
    en:'Creates Jira subtasks, test plans and detailed test specifications.' },
  { id:'DEV',   c:'#185FA5', r:'Developer',
    de:'Implementiert Code in isolierten Shards (max. 200 Zeilen), commitet auf GitHub.',
    en:'Implements code in isolated shards (max. 200 lines), commits to GitHub.' },
  { id:'QUINN', c:'#0C447C', r:'QA Engineer',
    de:'Führt Code-Reviews durch, prüft Tests und genehmigt Pull Requests.',
    en:'Conducts code reviews, validates tests and approves pull requests.' },
  { id:'OPS',   c:'#B0ADB8', r:'DevOps ✦',
    de:'Konfiguriert CI/CD-Pipelines und überwacht Deployments in Echtzeit. (Enterprise)',
    en:'Configures CI/CD pipelines and monitors deployments in real time. (Enterprise)' },
  { id:'DOC',   c:'#B0ADB8', r:'Documentation ✦',
    de:'Erstellt technische Dokumentation, Release Notes und Confluence-Seiten. (Enterprise)',
    en:'Creates technical documentation, release notes and Confluence pages. (Enterprise)' },
  { id:'LEX',   c:'#B0ADB8', r:'Compliance ✦',
    de:'Prüft Code auf DSGVO-Konformität, Open-Source-Lizenzen und Vertragsrecht. (Enterprise)',
    en:'Reviews code for GDPR compliance, open-source licenses and contract law. (Enterprise)' },
  { id:'MONA',  c:'#712B13', r:'Monitoring',
    de:'Überwacht SLOs, Latenz und Error Rates — schlägt Alarm bei Grenzwertverletzung.',
    en:'Monitors SLOs, latency and error rates — alerts on threshold violations.' },
  { id:'FINN',  c:'#0C5E4A', r:'Finance & ROI',
    de:'Berechnet monatlichen ROI, erstellt DATEV-kompatible Exporte und Kosten-Reports.',
    en:'Calculates monthly ROI, creates DATEV-compatible exports and cost reports.' },
  { id:'FLOW',  c:'#854F0B', r:'Workflow ✦',
    de:'Optimiert Prozessabläufe und orchestriert komplexe Automatisierungen. (Enterprise)',
    en:'Optimises workflows and orchestrates complex automations. (Enterprise)' },
  { id:'NOVA',  c:'#3B6D40', r:'Onboarding #21',
    de:'Onboardet neue Kunden vollautomatisch in unter 5 Minuten — Produkt, Epics, OKRs.',
    en:'Onboards new clients fully automated in under 5 minutes — product, epics, OKRs.' },
  { id:'SCAN',  c:'#6B3A2A', r:'Security #22',
    de:'Analysiert Code und Dependencies auf Sicherheitslücken (CVEs, OWASP Top 10).',
    en:'Analyses code and dependencies for vulnerabilities (CVEs, OWASP Top 10).' },
  { id:'VISU',  c:'#2D2D7A', r:'Visualization #23',
    de:'Erstellt Architektur-Diagramme, Miro-Boards und interaktive Visualisierungen.',
    en:'Creates architecture diagrams, Miro boards and interactive visualisations.' },
  { id:'MARK',  c:'#8B2D6E', r:'Marketing #24 ✦',
    de:'Erstellt Social-Media-Posts, E-Mail-Kampagnen und Launch-Inhalte. (Enterprise)',
    en:'Creates social media posts, email campaigns and launch content. (Enterprise)' },
  { id:'CLEO',  c:'#7B1F3A', r:'Executive #25',
    de:'Erstellt CEO-Briefings, Management-Reports und strategische Entscheidungsvorlagen.',
    en:'Creates CEO briefings, management reports and strategic decision papers.' },
  { id:'GARD',  c:'#993556', r:'DSGVO Guardian #26',
    de:'Prüft jeden Commit auf Datenschutz-Konformität — GARD schläft nicht.',
    en:'Checks every commit for data privacy compliance — GARD never sleeps.' },
  { id:'BIRA',  c:'#A32D2D', r:'BI & Reporting #27',
    de:'Baut Power-BI-Reports, prüft bestehende Modelle und refactort sie — messbar, nicht nach Gefühl.',
    en:'Builds Power BI reports, audits existing models and refactors them — measurably, not by gut feeling.' },
  { id:'CLOUD', c:'#1A5276', r:'Cloud Migration #28 ✦',
    de:'Migriert Infrastruktur zwischen Azure, AWS, GCP und On-Premise — mit Terraform und ohne Downtime. (Enterprise)',
    en:'Migrates infrastructure between Azure, AWS, GCP and on-premise — with Terraform and without downtime. (Enterprise)' },
  { id:'DATA',  c:'#1B4F72', r:'DWH & Data #29 ✦',
    de:'Migriert Data Warehouses mit Zero Data Loss — Schema, ELT-Strecken und Validierung vor dem Cutover. (Enterprise)',
    en:'Migrates data warehouses with zero data loss — schema, ELT pipelines and validation before cutover. (Enterprise)' },
];

async function init() {
  // Config aus Supabase laden (max. 3s, sonst Fallback)
  try {
    const headers = { apikey: SB_KEY, Authorization: 'Bearer ' + SB_KEY };
    const [cfgRows, anns] = await Promise.race([
      Promise.all([
        fetch(SB_URL + '/rest/v1/cs_content?id=eq.00000000-0000-0000-0000-000000000001&limit=1', { headers }).then(r => r.json()),
        fetch(SB_URL + '/rest/v1/cs_announcements?visible=eq.true&order=created_at.desc', { headers }).then(r => r.json()),
      ]),
      new Promise((_, rej) => setTimeout(() => rej(new Error('timeout')), 3000)),
    ]);
    const cfg = cfgRows?.[0];
    if (cfg) {
      if (cfg.launch_date)    LAUNCH = new Date(cfg.launch_date);
      if (cfg.spots_total)    SPOTS  = Math.max(0, cfg.spots_total - (cfg.spots_claimed || 0));
      if (cfg.badge_de && lang === 'de') T.de.badge = cfg.badge_de;
      if (cfg.badge_en && lang === 'en') T.en.badge = cfg.badge_en;
      if (cfg.warn_de)        T.de.warn  = cfg.warn_de;
      if (cfg.warn_en)        T.en.warn  = cfg.warn_en;
      if (cfg.cta_sub_de)     T.de.cta_s = cfg.cta_sub_de;
      if (cfg.cta_sub_en)     T.en.cta_s = cfg.cta_sub_en;
      if (cfg.features_count) { T.de.s3n = cfg.features_count.toLocaleString('de-DE'); T.en.s3n = cfg.features_count.toLocaleString('en-US'); }
      // Banner
      const banner = lang === 'de' ? cfg.announcement_de : cfg.announcement_en;
      if (banner) T[lang].banner = banner;
    }
    _announcements = Array.isArray(anns) ? anns : [];
  } catch (e) {
    console.info('CS config: using defaults —', e.message);
  }
  _beta = await ladeBetaProgramm(SB_URL, SB_KEY);

  render();
}

function render() {
const tx = T[lang] || T.de;
// Titel und Description tragen die Suchbegriffe (SEO, 08.09.2026) — je Sprache,
// damit der englische Besucher nicht den deutschen Titel im Tab sieht.
document.title = tx.meta_title;
const metaDesc = document.querySelector('meta[name="description"]');
if (metaDesc) metaDesc.setAttribute('content', tx.meta_desc);

const agGrid = AGENTS.map((a, i) =>
  `<div class="cs-ag" style="--ac:${a.c};--d:${(i * .13).toFixed(2)}s">
    ${a.id}
    <div class="cs-ag-tip">
      <div class="cs-ag-tip-name">${a.id}</div>
      <div class="cs-ag-tip-role">${a.r}</div>
      <div class="cs-ag-tip-desc">${lang === 'en' ? a.en : a.de}</div>
    </div>
  </div>`
).join('');

const annHtml = _announcements.length ? `
  <div class="cs-ann-bar">
    ${_announcements.slice(0,3).map(a => `
      <div class="cs-ann-item">
        <span class="cs-ann-emoji">${a.emoji}</span>
        <span><strong>${lang === 'de' ? a.title_de : a.title_en}</strong>${(lang === 'de' ? a.body_de : a.body_en) ? ' — ' + (lang === 'de' ? a.body_de : a.body_en) : ''}</span>
      </div>`).join('')}
  </div>` : '';

// Aktiver Banner aus dem CRM (cs_content.announcement_*) — bis 11.09.2026 wurde
// er zwar geladen, aber nie ins HTML gesetzt.
const bannerHtml = tx.banner ? `<div class="cs-banner">${tx.banner}</div>` : '';

const spotsLeft = (typeof SPOTS === 'number') ? SPOTS : 43;

document.getElementById('cs-root').innerHTML = `
<div class="cs-bg-grid"></div>
<div class="cs-bg-glow"></div>

<header class="cs-hdr">
  <a href="/" class="cs-logo" title="FORGE — Startseite"><span>${wordmarkHTML(19)}</span></a>
  <div class="cs-lang">
    <button class="cs-lb${lang==='de'?' on':''}" onclick="CSLang.set('de')">DE</button>
    <span class="cs-lsep">|</span>
    <button class="cs-lb${lang==='en'?' on':''}" onclick="CSLang.set('en')">EN</button>
  </div>
</header>

<main class="cs-main">
  ${bannerHtml}
  ${annHtml}
  <div class="cs-badge">${tx.badge}</div>
  ${betaHtml(_beta, tx, lang)}

  <h1 class="cs-h1">
    <span class="cs-h1a">${tx.h1a}</span>
    <span class="cs-h1b">${tx.h1b}</span>
    <span class="cs-h1c">${tx.h1c}</span>
  </h1>

  <p class="cs-sub">${tx.sub}</p>
  <p class="cs-warn">${tx.warn}</p>

  <div class="cs-cd-wrap">
    <div class="cs-cd-lbl">${tx.cd_lbl}</div>
    <div class="cs-cd">
      <div class="cs-cdb"><div class="cs-cdn" id="cd-d">--</div><div class="cs-cdu">${tx.D}</div></div>
      <div class="cs-sep">:</div>
      <div class="cs-cdb"><div class="cs-cdn" id="cd-h">--</div><div class="cs-cdu">${tx.H}</div></div>
      <div class="cs-sep">:</div>
      <div class="cs-cdb"><div class="cs-cdn" id="cd-m">--</div><div class="cs-cdu">${tx.M}</div></div>
      <div class="cs-sep">:</div>
      <div class="cs-cdb"><div class="cs-cdn" id="cd-s">--</div><div class="cs-cdu">${tx.S}</div></div>
    </div>
  </div>

  <div class="cs-ticker">
    <span class="cs-tdot"></span>
    <span id="cs-tick" class="cs-ttext">${tx.act[0]}</span>
  </div>

  <div class="cs-stats">
    <div class="cs-stat"><div class="cs-stn">${tx.s1n}</div><div class="cs-stl">${tx.s1l}</div></div>
    <div class="cs-sdiv"></div>
    <div class="cs-stat"><div class="cs-stn">${tx.s2n}<span>min</span></div><div class="cs-stl">${tx.s2l}</div><div class="cs-stx">${tx.s2x}</div></div>
    <div class="cs-sdiv"></div>
    <div class="cs-stat"><div class="cs-stn">${tx.s3n}<span>↑</span></div><div class="cs-stl">${tx.s3l}</div></div>
  </div>

  <div class="cs-funny">
    <div class="cs-fq">${tx.fq}</div>
    <div class="cs-fa">${tx.fa}</div>
    <div class="cs-fp">${tx.fp}</div>
  </div>

  <div class="cs-agents">
    <div class="cs-slbl">${tx.ag_l}</div>
    <div class="cs-ag-grid">${agGrid}</div>
  </div>

  <div class="cs-pipe">
    <div class="cs-slbl">${tx.pp_l}</div>
    <div class="cs-pipe-flow">${tx.pp_f}</div>
    <div class="cs-pipe-sub">${tx.pp_s}</div>
  </div>

  <div id="tr-mount"></div>

  <div class="cs-cta">
    <div class="cs-spots">● ${tx.spots.replace ? tx.spots.replace(String(SPOTS), String(spotsLeft)) : tx.spots}</div>
    <h2 class="cs-cta-h">${tx.cta_h}</h2>
    <p class="cs-cta-s">${tx.cta_s}</p>
    <div id="cs-form" class="cs-form">
      <input id="cs-email" type="email" placeholder="${tx.ph}" onkeydown="if(event.key==='Enter')csSubscribe()">
      <button onclick="csSubscribe()">${tx.btn}</button>
    </div>
    <div id="cs-ok" class="cs-ok" style="display:none">${tx.ok}</div>
    ${bookingHTML(tx)}
    <p class="cs-prom">${tx.prom}</p>
    <p class="cs-priv">${tx.priv}</p>
  </div>
</main>

<footer class="cs-foot">
  <p class="cs-foot-t">${tx.foot}</p>
  <p class="cs-foot-legal">
    <a href="/pages/impressum/">${tx.legal.imp}</a>
    <span>·</span>
    <a href="/pages/datenschutz/">${tx.legal.dat}</a>
    <span>·</span>
    <a href="/pages/agb/">${tx.legal.agb}</a>
  </p>
</footer>`;

// ── Countdown ───────────────────────────────────────────────
function tick() {
  const diff = LAUNCH - Date.now();
  if (diff <= 0) return;
  const vals = [
    Math.floor(diff / 86400000),
    Math.floor((diff % 86400000) / 3600000),
    Math.floor((diff % 3600000)  / 60000),
    Math.floor((diff % 60000)    / 1000),
  ];
  ['d','h','m','s'].forEach((id, i) => {
    const el = document.getElementById('cd-' + id);
    if (!el) return;
    const str = String(vals[i]).padStart(2, '0');
    if (el.textContent === str) return;
    el.textContent = str;
    el.classList.remove('pop');
    void el.offsetWidth;
    el.classList.add('pop');
  });
}
tick();
setInterval(tick, 1000);

// ── Ticker ─────────────────────────────────────────────────
const tickEl = document.getElementById('cs-tick');
let ti = Math.floor(Math.random() * tx.act.length);
if (tickEl) tickEl.textContent = tx.act[ti];
setInterval(() => {
  if (!tickEl) return;
  tickEl.style.opacity = '0';
  tickEl.style.transform = 'translateY(6px)';
  setTimeout(() => {
    ti = (ti + 1) % tx.act.length;
    tickEl.textContent = tx.act[ti];
    tickEl.style.opacity = '1';
    tickEl.style.transform = 'translateY(0)';
  }, 400);
}, 4500);

// ── Subscribe — speichert Lead in Supabase ─────────────────
window.csSubscribe = async () => {
  const inp   = document.getElementById('cs-email');
  const email = inp?.value.trim();
  if (!email?.includes('@')) {
    inp?.classList.add('shake');
    setTimeout(() => inp?.classList.remove('shake'), 500);
    return;
  }

  const btn = document.querySelector('#cs-form button');
  if (btn) { btn.textContent = '⏳…'; btn.disabled = true; }

  try {
    const params = new URLSearchParams(window.location.search);
    await fetch(SB_URL + '/rest/v1/leads', {
      method: 'POST',
      headers: {
        apikey: SB_KEY,
        Authorization: 'Bearer ' + SB_KEY,
        'Content-Type': 'application/json',
        Prefer: 'return=minimal',
      },
      body: JSON.stringify({
        email,
        source:       'coming_soon',
        status:       'new',
        utm_source:   params.get('utm_source')   || null,
        utm_medium:   params.get('utm_medium')   || null,
        utm_campaign: params.get('utm_campaign') || null,
      }),
    });
  } catch (e) {
    console.warn('Lead save skipped:', e.message);
  }

  document.getElementById('cs-form').style.display = 'none';
  document.getElementById('cs-ok').style.display   = 'flex';
  if (btn) { btn.textContent = tx.btn; btn.disabled = false; }
};

  initTrailer(lang, LAUNCH);
  mountBooking(tx, { url: SB_URL, key: SB_KEY }, lang);
  initChat();
}

init();
